// Static list of Fathom meeting variables, surfaced as a "Fathom" source in the
// dynamic-variables dropdown (same predefined-list pattern as account-variables).
// Names match the backend Fathom variable registry (integrations/fathom/service.js
// FATHOM_VARIABLES) so the share-dialog import writes the same `fathom.*` keys into
// version.data that these tokens resolve from. The first three are filled from the
// meeting's external invitee; the rest are AI-generated. Prompts/fill rules live on
// the backend — this list only provides names + display titles.
export const fathomVariables = [
  {
    _id: "fathom_0",
    plan: "paid",
    variable: {
      tab: "Content",
      group: "Fathom",
      type: "input",
      name: "fathom.first_name",
      title: "First name",
      default: "",
      tip: "The prospect's first name, from the meeting's external attendee.",
      validation: { required: false },
    },
  },
  {
    _id: "fathom_1",
    plan: "paid",
    variable: {
      tab: "Content",
      group: "Fathom",
      type: "input",
      name: "fathom.last_name",
      title: "Last name",
      default: "",
      tip: "The prospect's last name, from the meeting's external attendee.",
      validation: { required: false },
    },
  },
  {
    _id: "fathom_2",
    plan: "paid",
    variable: {
      tab: "Content",
      group: "Fathom",
      type: "input",
      name: "fathom.company_name",
      title: "Company name",
      default: "",
      tip: "The prospect's company, derived from their email domain.",
      validation: { required: false },
    },
  },
  {
    _id: "fathom_3",
    plan: "paid",
    variable: {
      tab: "Content",
      group: "Fathom",
      type: "input",
      name: "fathom.next_steps_summary",
      title: "Next steps summary",
      default: "",
      tip: "The single most important next step agreed in the meeting.",
      validation: { required: false },
    },
  },
  {
    _id: "fathom_4",
    plan: "paid",
    variable: {
      tab: "Content",
      group: "Fathom",
      type: "input",
      name: "fathom.personal_note",
      title: "Personal note",
      default: "",
      tip: "A short personalized opening referencing what was discussed.",
      validation: { required: false },
    },
  },
  {
    _id: "fathom_5",
    plan: "paid",
    variable: {
      tab: "Content",
      group: "Fathom",
      type: "input",
      name: "fathom.meeting_recap",
      title: "Meeting recap",
      default: "",
      tip: "A one-sentence recap of what the meeting covered.",
      validation: { required: false },
    },
  },
  {
    _id: "fathom_6",
    plan: "paid",
    variable: {
      tab: "Content",
      group: "Fathom",
      type: "input",
      name: "fathom.key_takeaways",
      title: "Key takeaways",
      default: "",
      tip: "The most important takeaways from the meeting.",
      validation: { required: false },
    },
  },
];
